import { Injectable } from '@angular/core';
import { CartRow, DeliveryDates, CalendarDate } from 'gung-standard';
import { JeevesDeliveryDateService } from 'gung-standard-jeeves';
import { parse } from 'date-fns';
import { Observable, map, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TyloDeliveryDateService extends JeevesDeliveryDateService {
  public getDeliveryDates(deliveryMethod: string, rows?: CartRow[]): Observable<CalendarDate[]> {
    const url = `json/delivery-dates?deliveryMethodCode=${deliveryMethod || ''}`;
    return this.http.get<DeliveryDates[]>(url).pipe(
      map(dates => {
        return dates.map(date => {
          return {
            ...date,
            date: parse(date.date, 'yyyy-MM-dd', new Date())
          };
        });
      }),
      switchMap(calendarDates => this.filterDeliveryDatesBySelectedFlow(calendarDates))
    );
  }
}
